import styles from "./style.module.scss";
import { Text } from "../../components/Text";
import { useState, useRef, useEffect } from "react";
import PaymentGateway from "../../components/PaymentGateway";
import { ReactComponent as Wallet } from "../../assets/svgIcons/wallet.svg";
import { Toast } from "primereact/toast";
import { useSelector, useDispatch } from "react-redux";
import {
  getOverAllCount,
  setAnalyticalRange,
} from "../../reducers/analyticSlice";
import { Skeleton } from "primereact/skeleton";
import { ReactComponent as PrintIcon } from "../../svg/printicon.svg";
import DashboardCard from "../../components/Cards/DashboardCards";
import axiosInstance from "../../api/axios.instance";
import { ReactComponent as DropdownIcon } from "../../assets/svgIcons/dropup.svg";
import { ReactComponent as GreenTickIcon } from "../../assets/svgIcons/greentick.svg";
import { addOneDay, getDate } from "../../utils/datemaker";
import { dateCompiler, getCampaignCustomers } from "../../utils/tableUtils";
import { Calendar } from "primereact/calendar";
import { useNavigate } from "react-router-dom";
import OrderPreview from "../Orders/OrderPreview";
import modulesName from "../../roles/modulesName";
import permissions from "../../roles/permissions";
import PostpaidAccountInfo from "../../components/PostpaidAcctountInfo";
import parseJwt from "../../utils/authUtils";
import PromotionModel from "./PromotionModel";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";
import { Tag } from "primereact/tag";
import { ReactComponent as DashCustomerIcon } from "../../assets/svgIcons/dashcustomer.svg";
import { ReactComponent as DashUserIcon } from "../../assets/svgIcons/dashuser.svg";
import { ReactComponent as DashConversationIcon } from "../../assets/svgIcons/dashconversation.svg";

const StatisticalRecord = () => {
  const [gateway, setGateway] = useState(false);
  const { selectedOrdersList } = useSelector((state) => state.orderTable);
  const { userSub, user, conversation, accesskey } = useSelector(
    (state) => state.authenticate
  );
  const { company } = useSelector((state) => state.company);
  const [putLogo, setPutLogo] = useState("");
  const [getLogo, setGetLogo] = useState("");
  const [previewOrder, setPreviewOrder] = useState(false);
  const [showPromo, setShowpromoCode] = useState(false);
  const isPostpaid = conversation?.paymentType === "postpaid";

  const navigate = useNavigate();
  const toast = useRef(null);
  const dispatch = useDispatch();
  const SKALEBOT_URL = process.env.REACT_APP_SKALEBOT_APP_URL;

  const isEnvUrlMatch =
    SKALEBOT_URL &&
    window.location?.origin.toLowerCase() === SKALEBOT_URL.toLowerCase();
  const isLocalhost = window.location.hostname === "localhost";

  // order printout
  const openPreview = () => {
    setPreviewOrder(true);
  };

  const orderPreviewModal = () => {
    return (
      <OrderPreview
        previewOrder={previewOrder}
        setPreviewOrder={setPreviewOrder}
        toast={toast}
      />
    );
  };

  const handlegateway = () => {
    //setGateway(true);
    navigate("/dashboard/recharge");
  };

  const { overAllCount, loading } = useSelector((state) => state.analytic);
  const loderSkaleton = () => {
    return (
      <Skeleton
        width={"5rem"}
        height={"3rem"}
        borderRadius={"4px"}
        className="mb-2"
      />
    );
  };
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();

  // useEffect(
  //   () => {
  //     let tzoffset = new Date().getTimezoneOffset() * 60000;
  //     const date = {
  //       startDate: fromDate
  //         ? new Date(fromDate - tzoffset).toISOString().substring(0, 10)
  //         : fromDate,
  //       endDate: toDate
  //         ? new Date(toDate - tzoffset).toISOString().substring(0, 10)
  //         : toDate,
  //     };
  //     console.log("company", company)

  //     dispatch(getOverAllCount(date))
  //       .unwrap()
  //       .catch(() => {
  //         //show toast from here
  //       });
  //   },
  //    toDate ? [toDate, fromDate] : [toDate]
  // );

  useEffect(() => {
    let tzoffset = new Date().getTimezoneOffset() * 60000;
    const date = {
      startDate: fromDate
        ? new Date(fromDate - tzoffset).toISOString().substring(0, 10)
        : fromDate,
      endDate: toDate
        ? new Date(toDate - tzoffset).toISOString().substring(0, 10)
        : toDate,
    };
    dispatch(getOverAllCount(date))
      .unwrap()
      .catch(() => {
        //show toast from here
      });
  }, []);

  const gatewayPopup = () => {
    return (
      <PaymentGateway
        gateway={gateway}
        setGateway={setGateway}
        category={"TOPUP"}
        toast={toast}
      />
    );
  };
  useEffect(() => {
    editRange("week");
    // var today = new Date()             // uncomment this for by default today's date
    // var yesterday = new Date(today)
    // yesterday.setHours(0, 0, 0, 0)
    // modifyRange([yesterday, null])
    axiosInstance
      .get(`company/${user.companyId}/image`)
      .then((resp) => {
        setGetLogo(resp.data.url);
        setPutLogo(resp.data.src);
      })
      .catch((err) => {
        console.log(err);
      });
    // console.log(userSub);
    if (userSub && userSub?.plan === "none") {
      // console.log(userSub, "adsasd");
      setShowpromoCode(true);
    } else {
      setShowpromoCode(false);
    }
    return () => {
      dispatch(setAnalyticalRange({ fromDate: null, toDate: null }));
      setGetLogo("");
      setPutLogo("");
    };
  }, []);

  const colorBg = (x) => (x >= 50 ? "#4CAF50" : "#F44336");
  const colortxt = (x) => (x >= 50 ? "#2E7D32" : "#C62828");
  const colorbgtxt = (x) => (x >= 50 ? "#E6F4EA" : "#FDECEA");

  const analyticsItems = () => {
    const totalCustomers = overAllCount?.customerCount;
    const totalUsers = overAllCount?.usersCount;
    const conversationsUsed = conversation?.used;
    const conversationsLimit = conversation?.total;

    const percentage =
      Math.round((conversationsUsed / conversationsLimit) * 100) + 50;

    const leftSection = (
      <div className="flex flex-column w-5">
        <div className="flex align-items-center h-1rem gap-2 pb-4">
          <div className="p-1">
            <DashCustomerIcon />
          </div>
          <span className="font-normal p-1 mt-1">
            Total Customers{" "}
            <strong className="font-bold">{totalCustomers}</strong>
          </span>
        </div>
        <div className="flex align-items-center h-1rem gap-2">
          <div className="p-1">
            <DashUserIcon />
          </div>
          <span className="font-normal ">
            Total Users <strong className="font-bold">{totalUsers}</strong>
          </span>
        </div>
      </div>
    );

    const rightSection = (
      <div className="flex flex-column w-7 gap-1">
        <div className="flex gap-2 align-items-center mb-1">
          <DashConversationIcon />
          <span className="font-normal text-base">Conversations</span>
          <span className="font-semibold">
            <span className="font-bold">
              {conversationsUsed ? conversationsUsed : 0}
            </span>
            /{conversationsLimit}
          </span>
        </div>
        {conversation?.used > 0 ? (
          <div className="flex flex-row align-items-center gap-2 w-12 mb-1 ">
            <div className="w-11">
              <ProgressBar
                value={percentage}
                showValue={false}
                className={` ${styles["percentage-bar"]}`}
                color={`${colorBg(percentage)}`}
                style={{ height: "6px", background: "#E9ECEF" }}
              />
            </div>
            <div className="w-1">
              <Tag
                value={`${percentage}%`}
                className={` ${styles["percentage-bar-tag"]}`}
                style={{
                  background: `${colorbgtxt(percentage)}`,
                  color: `${colortxt(percentage)}`,
                }}
              />
            </div>
          </div>
        ) : (
          <div></div>
        )}
        <div className="flex justify-content-center items-center">
          <Button
            label="Recharge plan"
            outlined
            className={`cursor-pointer border-round-xl ${styles["handlegatewaybtn"]}`}
            onClick={handlegateway}
          />
        </div>
      </div>
    );

    return (
      <div
        className={`w-full lg:py-3 lg:px-4 p-2 ${styles["sub-cont"]}  mt-2 justify-content-center md:w-6  xl:w-5 `}
      >
        <div
          className={`flex flex-row justify-content-evenly align-items-center gap-2 ${styles["subscribe-container"]}`}
        >
          {leftSection}
          {conversation?.used > 0 &&
          accesskey[modulesName.PAYMENT]?.includes(permissions.READ) ? (
            <div
              className={`${styles["tv-line"]}`}
              style={{ background: "#ECEDF1" }}
            ></div>
          ) : (
            <div className="hidden"></div>
          )}
          {conversation?.paymentType === "postpaid" &&
          accesskey[modulesName.PAYMENT]?.includes(permissions.READ) ? (
            rightSection
          ) : (
            <div className="hidden"></div>
          )}
        </div>
      </div>
    );
  };

  const timeline = [
    {
      id: "all",
      name: "Lifetime",
      value: "all",
    },
    {
      id: "month",
      name: "Month",
      value: "month",
    },
    {
      id: "week",
      name: "Last 7 days",
      value: "week",
    },
  ];

  const [range, setRange] = useState("all");
  const [dateValue, setdateValue] = useState(null);

  const editRange = (mode) => {
    let d = new Date();
    switch (mode) {
      case "month":
        setRange("month");
        var old = new Date();
        old.setDate(1);
        setdateValue([old, d]);
        dispatch(
          setAnalyticalRange({
            fromDate: old.toISOString(),
            toDate: d?.toISOString(),
            type: mode,
          })
        );
        return;
      case "week":
        setRange("week");
        var old = new Date();
        old.setDate(old.getDate() - 7);
        setdateValue([old, d]);
        dispatch(
          setAnalyticalRange({
            fromDate: old.toISOString(),
            toDate: d?.toISOString(),
            type: mode,
          })
        );
        return;
      default:
        setRange("all");
        setdateValue(null);
        dispatch(
          setAnalyticalRange({ fromDate: null, toDate: null, type: mode })
        );
        return;
    }
  };
  const modifyRange = (range) => {
    setdateValue(range);
    setRange("custom");
    dispatch(
      setAnalyticalRange({
        fromDate: addOneDay(range[0]?.toISOString()),
        toDate: addOneDay(range[1]?.toISOString()),
      })
    );
  };

  const [showAccDetails, setshowAccDetails] = useState(false);
 
  return (
    <div>
      <div
        className={` ${styles["record-wrap-stat"]} ${styles.dashboard_section}`}
        // className={styles.dashboard_section}
      >
        {gateway && gatewayPopup()}
        {orderPreviewModal()}
        <Toast ref={toast} />
        <div
          className={`w-full px-3 lg:py-3  py-3 flex flex-column justify-content-between align-items-start  w-12 ${styles["record-cont"]}`}
        >
          <div className="flex flex-column-reverse  lg:flex-row justify-content-between w-full">
            <div className="text-xm font-semibold flex flex-row gap-2 align-items-center pr-2">
              <Text type={"heading"} style={{ fontSize: `1.2rem` }}>
                Account Information
              </Text>
              <div
                className={`pl-2 cursor-pointer `}
                onClick={() => {
                  setshowAccDetails((x) => !x);
                }}
              >
                <div className={` ${showAccDetails ? `rotate-180` : `pt-1`}  `}>
                  <DropdownIcon />
                </div>
              </div>
            </div>
            <div className="flex flex-row flex-wrap justify-content-start lg:justify-content-end gap-2 p-1 ">
              {timeline.map((x, index) => {
                return (
                  <div
                    key={index}
                    className={`flex cursor-pointer p-2 ${
                      styles["selected-range"]
                    } ${x.value === range ? `${styles["select-range"]}` : ""} `}
                    onClick={() => {
                      editRange(x.value);
                    }}
                  >
                    {x.name}
                  </div>
                );
              })}
              <div className="flex cursor-pointer flex-row align-items-center">
                <Calendar
                  showIcon={true}
                  placeholder="DD/MM/YYYY"
                  dateFormat="dd/mm/yy"
                  className={`${
                    dateValue !== null ? `${styles["selectedDate"]}` : ``
                  } ${styles["dashboardDate"]} `}
                  value={dateValue}
                  onChange={(e) => modifyRange(e.value)}
                  selectionMode="range"
                  maxDate={new Date()}
                ></Calendar>
                {/* <div className={`block cursor-pointer pl-2 pt-1 cursor-pointer ${!selectedOrdersList?.length?'opacity-60':''}`} onClick={()=>{(selectedOrdersList?.length)&&openPreview()}}>
                      <PrintIcon />
                    </div> */}
              </div>
            </div>
          </div>
          {showAccDetails && (
            <div className="w-12 flex  flex-row justify-content-between align-items-center flex-wrap w-12">
              <div
                className={`w-full flex flex-row justify-content-between align-items-center flex-wrap w-12 sm:w-12 md:w-6 `}
              >
                <div className="flex flex-row  align-items-center">
                  <div className="flex flex-row justify-content-between align-items-center w-6rem h-8rem">
                    <img
                      src={`${getLogo}?v=${new Date().getTime()}`}
                      onError={(e) =>
                        (e.target.src = "./svgIcons/UserIcon.svg")
                      }
                      alt="Company logo"
                      className="logoImg w-8rem h-8rem"
                      style={{ maxHeight: "80px" }}
                    />
                  </div>
                  <div>
                    <div className="text-xm font-semibold">Account Name</div>
                    <div className="font-semibold flex flex-row gap-2  align-items-center h-2rem">
                      <div className="pt-2 text-base">
                        {company?.companyName}
                      </div>
                      <div className="h-1rem ">
                        <GreenTickIcon />
                      </div>
                    </div>
                    <div className="flex flex-row  py-1 ">
                      <div className="font-normal mr-2">Plan validity :</div>
                      <div className=" font-semibold text-base">
                        {dateCompiler(conversation?.endTime)}
                      </div>
                      {/* {accesskey[modulesName.PAYMENT]?.includes(permissions.CREATE) &&<div className=" text-base px-1 cursor-pointer" onClick={handlegateway}><i class="pi pi-external-link"></i></div>} */}
                    </div>
                  </div>
                </div>
              </div>
              {analyticsItems()}
            </div>
          )}

          {isPostpaid && (
            <div className={`w-full mt-4`}>
              <PostpaidAccountInfo />
            </div>
          )}
          {(isEnvUrlMatch || isLocalhost) && (
            <PromotionModel
              showModel={showPromo}
              setShowModel={setShowpromoCode}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default StatisticalRecord;
